<template>
  <div class="properties-wrapper">
    <div
      v-for="(item, propertyIndex) in properties"
      :key="item.question"
      class="property-list"
    >
      <transition name="list">
        <div v-if="item.selected || item.showAnswers">
          <!-- 单选 -->
          <div v-if="multiSelectId != item.id">
            <div ref="item" class="property-header" @click="showAnswers(propertyIndex)">
              <div class="title">
                <span>{{ propertyIndex + 1 }}. {{ item.question }}</span>
                <img v-if="item.specDesc || (item.specImageList && item.specImageList.length>0)" class="icon-what" src="@/assets/image/property/icon-what@2x.png" @click.stop="showDescUppop(item, propertyIndex + 1)"/>
              </div>
              <span class="selected">{{ item.selected.optionName }}</span>
              <div v-if="item.selected" :class="['edit', item.showAnswers ? 'route' : 'route1']">
                <img src="@/assets/image/property/arrow.png"/>
              </div>
            </div>
            <!--答案项列表（单选）-->
            <transition name="slide-fade">
              <ul v-show="item.showAnswers" class="answers-wrapper">
                <item-err-tip :txt="item.specHint"></item-err-tip>
                <template v-for="answer in item.optionList">
                  <li
                    v-if="!hideAnswer(item, answer.id)"
                    :key="answer.id"
                    class="answer_li"
                    :class="[{ active: item.selected.id === answer.id, disable: canNotOpenOptions.indexOf(answer.id)!== -1 && item.keyName=='standardSpecificationList' }]"
                    @click="selectAnswer(propertyIndex, answer, item.keyName)"
                  >
                    <p class="name">
                      <!-- <i
                        class="i-question"
                        @click.stop="showQuestionPopup(answer)"
                        v-if="answer.specContent"
                        >?
                      </i> -->
                      {{ answer.optionName }}
                    </p>
                    <!-- <p class="desc" v-if="answer.specContent">
                      {{ answer.specContent }}
                    </p> -->
                    <div v-if="answer.answerDesc || (answer.answerImageList && answer.answerImageList.length>0)" class="box-anserImg" @click.stop="showDescUppop(item, propertyIndex + 1, answer)">
                      <van-image
                        v-if="answer.answerImageList && answer.answerImageList.length>0"
                        class="img-anserImg"
                        fit="cover"
                        :src="answer.answerImageList[0]"
                      />
                      <!-- <img class="img-anserImg" v-else src="@/assets/img/img-default-phone.png"/> -->
                      <!-- <img class="img-enlarge" src="@/assets/icon/icon-enlarge@2x.png"/> -->
                    </div>
                    <img v-if="item.selected.id === answer.id" class="checked" src="../../../assets/image/property/checked.png" alt="">
                  </li>
                </template>
                <!-- 苹果机的型号和购买渠道显示对应操作图 -->
                <!-- 型号 -->
                <!--文本为：型号-->
                <div
                  v-if="brandId === 2 && item.question === 'Model'"
                  class="guide-wrapper"
                >
                  <!--文本为：您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号-->
                  <p class="entrance">您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号</p>
                </div>
                <!-- 购买渠道 -->
                <div
                  v-if="brandId === 2 && item.question === '购买渠道'"
                  class="guide-wrapper"
                >
                  <!--文本为：您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号-->
                  <p class="entrance">您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号</p>
                  <p>
                    <!--文本为：N开头是官换机；F开头是官翻机/官修机；3开头是 展示机；-->
                    <span class="order">1</span
                    >N开头是官换机；F开头是官翻机/官修机；3开头是 展示机；
                  </p>
                  <p>
                    <span class="order">2</span
                    >其中CH是中国市场的机器，ZP是香港市场的机器，不是CH/ZP，是便携的。
                  </p>
                  <!--文本为：有锁无锁？-->
                  <p class="title">有锁无锁？</p>
                  <!--文本为： 插上其他卡看是否能正常通话辨别有无锁，有锁一般
                    需要激活，无法正常通话。-->
                  <p>
                    插上其他卡看是否能正常通话辨别有无锁，有锁一般需要激活，无法正常通话。
                  </p>
                </div>
              </ul>
            </transition>
          </div>
          <!-- 多选 -->
          <div v-if="multiSelectId == item.id && isAllSelected">
            <div class="property-header border-top-1px">
              <!--文本为：可选可不选-->
              <!-- <span class="title"
                >{{ properties ? properties.length : ''}}.
                {{ `${item.question} (${$t('other.chooseOrNot')})` }}</span
              > -->
              <div class="title">
                <span>{{ properties ? properties.length : ''}}.{{  `${item.question} (可选可不选)` }}</span>
                <!-- <img class="icon-what" src="@/assets/icon/icon-what@2x.png" v-if="item.specDesc || (item.specImageList && item.specImageList.length>0)" @click.stop="showDescUppop(item, properties ? properties.length : '')"/> -->
              </div>
            </div>

            <!--功能性答案项列表（可多选）-->
            <transition name="slide-fade">
              <ul
                class="answers-wrapper"
                :class="[{ show: item.showAnswers }, 'clearfix']"
              >
                <item-err-tip :txt="item.specHint"></item-err-tip>
                <template v-for="answer in item.optionList">
                  <li
                    v-if="!hideAnswer(item, answer.id)"
                    :key="answer.id"
                    class="answer_li"
                    :class="[
                      { active: item.selected.includes(answer.optionName), disable: canNotOpenOptions.indexOf(answer.id)!==-1 && item.keyName=='standardSpecificationList'  },
                      'fl',
                    ]"
                    @click="multiSelectAnswer(propertyIndex, answer.optionName, answer.id, item.keyName)"
                  >
                    <span class="name">{{ answer.optionName }}</span>
                    <!-- <img class="icon-what-answer" src="@/assets/icon/icon-what@2x.png" v-if="answer.answerDesc || (answer.answerImageList && answer.answerImageList.length>0)" @click.stop="showDescUppop(item, properties ? properties.length : '', answer)"/> -->
                    <img v-if=" item.selected.includes(answer.optionName)" class="checked" src="../../../assets/image/property/checked.png" alt="">
                  </li>
                </template>
              </ul>
            </transition>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="properties.length > 0 && current >= properties.length" class="property-list">
      <transition name="list">
        <!-- imei -->
        <div>
          <div ref="item" class="property-header">
            <div class="title titles">
              <span>{{ properties.length + 1 }}. {{ $t('PCPropertyList.index.imeiLabel') }}</span>
            </div>
          </div>
          <!--答案项列表（单选）-->
          <transition name="slide-fade">
            <div class="answers-wrapper">
              <div class="input-content">
                <input v-model="imei" type="number" class="input" :placeholder="$t('PCPropertyList.index.pleaseEnter')" oninput="if(value.length>15)value=value.slice(0,15)" />
                <div class="number">{{ imei ? imei.length : 0 }}/15</div>
              </div>
            </div>
          </transition>
          <div class="imei-tip">{{ $t('PCPropertyList.index.646ynp3uem40') }}</div>
        </div>
      </transition>
    </div>

    <!-- <div v-if="properties.length > 0 && current >= properties.length + 1" class="property-list">
      <transition name="list">
        <div>
          <div class="property-header" ref="item">
            <div class="title titles">
              <span>{{ properties.length + 2 }}. Promotion code</span>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="answers-wrapper">
              <div class="input-content">
                <input v-model="qrcode" class="input" placeholder="Please enter" @input="qrcodeVerify"  />
                <div class="number"> {{ qrcode ? qrcode.length : 0 }}/6 </div>
              </div>
            </div>
          </transition>
          <div class="imei-tip" v-if="showErrorCode" style="color: #EE0A24">{{ $t('component.tradeInProcess.invalidCode') }}</div>
          <div class="imei-tip">Enter the promo code to get extra discounts.</div>
        </div>
      </transition>
    </div> -->
    <question-pupup ref="question" :data="questionData"></question-pupup>
    <!-- 不回收此类机型 我知道了 -->
    <van-dialog v-model="show_notChoose" show-confirm-button
                theme="round-button"
                :message="$t('successOrder.successOrder.notRecyclable')"
                :confirm-button-text="$t('successOrder.successOrder.IKnow')"
                confirm-button-color="#405FFF">
    </van-dialog>

    <!-- 问题&答案描述弹窗 -->
    <DescPopup ref="descPopup"></DescPopup>
  </div>
</template>

<script>
import {
  checkQrCode
} from '@/services/api/product';

import formatProperties from '../../../utils/device';
import DescPopup from './descPopup/DescPopup.vue'
import itemErrTip from './item-err-tip.vue';
import QuestionPupup from './question-pupup.vue';
export default {
  components: {
    QuestionPupup,
    itemErrTip,
    DescPopup
  },
  // props: ["data", "brandId", "multiSelectId", "canNotOpenOptions"],
  props: {
    data: {},
    brandId: {},
    multiSelectId: {},
    canNotOpenOptions: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      questionData: {
        title: '',
        url: '',
        content: ''
      },
      show_notChoose: false,
      isTgddAgent: Boolean(JSON.parse(window.localStorage.getItem('dhUserInfo'))?.tgdd),
      imei: null,
      qrcode: this.$route.query.qrcode || '',
      showErrorCode: false
    };
  },
  computed: {
    properties() {
      return formatProperties(this.data, this.brandId);
    },
    /**
     * 判断前面的答案项是否全勾选
     */
    isAllSelected() {
      const propertiesExcludeLastOne = JSON.parse(
        JSON.stringify(this.properties)
      );
      propertiesExcludeLastOne.pop();
      const isAllSelected = propertiesExcludeLastOne.every((item) => item.selected);
      return isAllSelected;
    }
  },
  watch: {
    imei: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.$emit('changeCurrent', this.imei)
      }
    }
  },
  methods: {
    qrcodeVerify() {
      console.log(this.qrcode)
      if (this.qrcode.length>6) {
        this.qrcode=this.qrcode.slice(0,6);
      }
      if (this.qrcode && this.qrcode.length == 6) {
        checkQrCode({
          qrCode: this.qrcode,
          channelId: 100000,
          nation: 'ES'
        })
          .then((res) => {
            if (res.code == '0000'){
              this.showErrorCode = !res.data
              if (res.data){
                this.$emit('changeQrcode',this.qrcode)
              } else {
                this.$emit('changeQrcode','')
              }
            }
          })
          .catch(err => {
            console.log(108, err);
          });
      } else {

        this.$emit('changeQrcode','')
        this.showErrorCode = false
      }
    },
    /**
     * 显示问号弹窗
     */
    showQuestionPopup(answer) {
      this.questionData.title = answer.name;
      this.questionData.url = answer.specImageShow;
      this.questionData.content = answer.specContent;
      this.$refs.question.show();
    },
    /**
     * 显示答案项列表
     * @param propertyIndex
     */
    showAnswers(propertyIndex) {
      this.$emit('showAnswers', propertyIndex);
    },
    /**
     * 选择答案（单选）
     * @param propertyIndex
     * @param answer
     */
    selectAnswer(propertyIndex, answer, keyName) {
      if (this.canNotOpenOptions.indexOf(answer.id) !== -1 && keyName=='standardSpecificationList'){
        this.show_notChoose = true
        return
      }
      this.$emit('selectAnswer', propertyIndex, answer);
    },
    /**
     * 功能性问题选择答案（可多选或不选）
     * @param propertyIndex
     * @param name
     */
    multiSelectAnswer(propertyIndex, name, id, keyName) {
      if (this.canNotOpenOptions.indexOf(id) !==-1 && keyName=='standardSpecificationList'){
        this.show_notChoose = true
        return
      }
      this.$emit('multiSelectAnswer', propertyIndex, name);
    },
    // 字符串截取
    stringSplice(str) {
      if (str.length > 10) {
        return str.slice(0, 10) + '...'
      }
      return str
    },
    hideAnswer(item, answerID){
      if (this.isTgddAgent && item.keyName==='standardSpecificationList' && (answerID === 20 || answerID === 21)){
        return true
      }
      return false
    },
    // 显示问题/答案详情弹窗
    showDescUppop(question, index, answer){
      const obj = {
        question,
        indexNum: index,
        answer
      }

      this.$refs?.descPopup?.show(obj)
    }
  }
};
</script>

<style lang="less" scoped>
// @import "../../../styles/reset.scss";
.active {
  border-color: #405FFF !important;
  color: var(--theme-color) !important;
  background: #FFF5EB !important;
}
.disable{
  color: #c4c7cc !important;
}
.properties-wrapper{
  box-sizing: border-box;
  padding: 24px;
  margin-top: 260px;
}
.property-list {
  background: #fff;
  margin-bottom: 24px;
  box-sizing: border-box;
  border-radius: 16px;
  .imei-tip{
    margin: 0 20px;
    padding-bottom: 20px;
  }
  .property-header {
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px 24px;
    font-size: 28px;
    .title {
      max-width: 450px;
      font-size: 28px;
      color: #333333;
      display: flex;
      align-items: center;
      font-weight: 500;
      overflow:hidden; /*超出的部分隐藏起来。*/
      // white-space:nowrap;/*不显示的地方用省略号...代替*/
      text-overflow:ellipsis;/* 支持 IE */
      .icon-what{
        width: 14px;
        height: 30px;
        margin-left: 7px;
        margin-right: 25px;
        box-sizing: border-box;
        padding: 8px 0;
      }
    }
    .titles {
      max-width: 564px;
    }
    .selected {
      flex: 1;
      text-align: right;
      color: #808080;
      display: -webkit-box; /** 将对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 1; /** 显示的行数，显示高度设置成行高，多余部分隐藏 **/
      overflow: hidden;  /**超出部分隐藏 **/
    }
    .edit {
      color: #808080;
      display: flex;
      align-items: center;
      transform: rotate(180deg);
      img {
        width: 32px;
        height: 32px;
        // margin-left: 16px;
      }
    }
    .route {
      transform: rotate(0deg);
    }
    .route1 {
      // transform: rotate(180deg);
    }
  }
  .answers-wrapper {
    margin: 5px 0 5px 0;
    padding: 0 20px;
    word-wrap: break-word;
    display: flex;
    flex-direction: column;
    li {
      width: 100%;
      min-height: 120px;
      // padding: 15px;
      padding: 16px 24px;
      font-size: 15px;
      border-radius: 12px;
      color: #666;
      margin-bottom: 12px;
      background: #f7f7f7;
      border: 1px solid #f7f7f7;
      box-sizing: border-box;
      position: relative;
      .name {
        display: flex;
        align-items: center;
        .i-question {
          width: 15px;
          min-width: 15px;
          -webkit-box-orient: vertical;
          height: 15px;
          background: #ccc;
          color: #fff;
          font-size: 12px;
          border-radius: 50%;
          text-align: center;
          line-height: 15px;
          margin-right: 11px;
        }
      }
      .desc {
        color: #808080;
        font-size: 13px;
        margin-top: 5px;
      }
      .checked {
        width: 48px;
        height: 48px;
        position: absolute;
        top: -2px;
        right: -2px;
      }
    }
    .guide-wrapper {
      background: #f4f5f8;
      border-radius: 5px;
      margin-top: 30px;
      padding: 16px;
      font-size: 12px;
      color: #333;
      .entrance {
        color: #808080;
        span {
          color: #333;
          font-weight: 600;
        }
      }
      p {
        font-size: 12px;
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
        .order {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #415fff;
          color: #fff;
          line-height: 16px;
          text-align: center;
          margin-right: 8px;
        }
      }
      .title {
        font-size: 13px;
        font-weight: 600;
      }
      img {
        width: 100%;
        height: 106px;
        margin-bottom: 17px;
        border-radius: 5px;
      }
    }
    .answer_li{
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .name {
        flex: 1;
        font-size: 28px;
        font-weight: 500;
      }
      .icon-what-answer{
        width: 16px;
        height: 30px;
        box-sizing: border-box;
        padding: 7px 0;
        margin-left: 7px;
      }
      .imgBox{
        width: 50px;
        height: 50px;
        background: pink;
      }
      .box-anserImg{
        width: 64px;
        height: 64px;
        position: relative;
        border-radius: 6px;
        .img-anserImg{
          width: 64px;
          height: 64px;
          border-radius: 6px;
        }
        .img-enlarge{
          width: 18px;
          height: 18px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
  .input-content {
    position: relative;
    .input {
      width: 100%;
      height: 92px;
      background: #f7f7f7;
      padding: 32px 24px;
      box-sizing: border-box;
      color: #333;
      font-size: 28px;
      border: none;
      border-radius: 12px;
      margin-bottom: 24px;
    }
    .number {
      position: absolute;
      top: 32px;
      right: 24px;
      font-size: 24px;
      color: #999;
    }
  }
}
/deep/ .box-anserImg{
  img{
    border-radius: 6px;
  }
}
</style>
